module.exports = __webpack_public_path__ + "img/weather57.5d4ebc9a.png";